export default __webpack_public_path__ + "static/media/966.c54285dc.png";